class ProductViewPopup {
	constructor() {
		this.selectors = {
			document: document,
			body: 'body',
		};
		this.init();
		this.timeout_1 = null;
		this.timeout_2 = null;
		this.events();
	};
	init() {
		this.getNodes();
	}

	getNodes() {
		var _this = this;
		this.nodes = {};
		$.each(this.selectors, function(key, selector) {
			_this.nodes[key] = $(selector);
		});
	}

	events() {
    
    $(document).find('.product_view_wrap_slider [data-img-name]').children('a').fancybox();
    //  product view click slider
    $(document).on('click', '.js-product-image', function(e){
      e.preventDefault();

      var $this = $(this);
          $this.closest('.carousel').find('.current').removeClass('current');
          $this.parent().addClass('current');

      $('.product_view_wrap_slider [data-img-name=' + $this.data('imgName') + ']').addClass('active').siblings().removeClass('active');

    });

    $('.popup-link').magnificPopup({
        type:'inline',
        midClick: true
    });

    //  video
    $(document).on("mouseup", '.js-popup-video', function(event) {

        event.preventDefault();

        var target = $(event.currentTarget);

        target.magnificPopup({
            type: 'iframe',
            iframe:{
                patterns:{
                    youtube:{
                        index: 'youtube.com/',
                        id: '/',
                        src: '//www.youtube.com/embed/%id%'
                    },
                    youtu:{
                        index: 'youtu.be/',
                        id: 'v=',
                        src: '//www.youtube.com/embed/%id%'
                    },
                    vimeo:{
                        index: 'vimeo.com/',
                        id: '/',
                        src: '//player.vimeo.com/video/%id%'
                    },
                    play:{
                        index: 'play.md/',
                        id: '/',
                        src: '//play.md/embed/%id%?title=false'
                    }
                }
            }
        });

    });
  }
}
new ProductViewPopup()
